import { registerPlugin } from '@capacitor/core';
const SpeechSynthesis = registerPlugin('SpeechSynthesis', {
    web: () => import('./web').then((m) => new m.SpeechSynthesisWeb()),
});
export * from './definitions';
export { SpeechSynthesis };
//# sourceMappingURL=index.js.map